import {
  SET_CURRENT_PATH,
  SET_INTERNAL_TRANSITION,
} from '../../constants/history';

export const setInternalTransition = () => ({ type: SET_INTERNAL_TRANSITION });

export const setCurrentPath = (payload: string) => ({
  type: SET_CURRENT_PATH,
  payload,
});
